import { css } from '@fable/theme'
import { Button } from '@fable/components'
import { analytics } from 'analytics'
import { useDeviceDetect } from '@fable/hooks'
import { SharePageQR } from 'app/social/pages/share_page/SharePageQR'

export const DownloadAppCardActions: React.VFC = () => {
  const { isMobile } = useDeviceDetect()

  return (
    <>
      <Button
        className={css`
          width: 130px;
          display: ${isMobile ? 'block' : 'none'};
        `}
        label="Download"
        onClick={() => analytics.actions.appDownloadDeeplink()}
        negative
      />
      <SharePageQR
        className={css`
          display: ${isMobile ? 'none' : 'block'};
          margin: 0 auto;
          z-index: 0;
        `}
        hideOnMobileLayout={false}
      />
    </>
  )
}
